var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "facebook__login card p-3 text-center bg-info" },
        [
          _c("div", { staticClass: "text" }, [
            _c("h3", { staticClass: "text-white" }, [_vm._v("Facebook Login")]),
            _c("p", { staticClass: "text-white" }, [
              _vm._v("Login with Facebook to view all your posts"),
            ]),
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center",
                attrs: { id: "app" },
              },
              [
                _c("v-facebook-login", {
                  attrs: { "app-id": _vm.appid[0].appId },
                  on: { "sdk-init": _vm.handleSdkInit, login: _vm.onLogin },
                  model: {
                    value: _vm.model,
                    callback: function ($$v) {
                      _vm.model = $$v
                    },
                    expression: "model",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-content-center mb-1" },
        [
          !_vm.connected
            ? _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning", block: "" },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._l(_vm.report.data, function (item) {
        return _c(
          "b-card",
          { key: item.id },
          [
            _c("b-card-title", { staticClass: "mb-1" }, [
              _vm._v(" " + _vm._s(item.title)),
            ]),
            _c("b-card-sub-title", { staticClass: "mb-2" }, [
              _vm._v(" " + _vm._s(item.description) + " "),
            ]),
            _c("vue-apex-charts", {
              attrs: {
                height: "350",
                type: "line",
                options: _vm.chartOptions(item.values),
                series: _vm.chartData(item.values),
              },
            }),
          ],
          1
        )
      }),
      _vm._l(_vm.reportPost.data, function (item) {
        return _c(
          "b-card",
          { key: item.id },
          [
            _c("b-card-title", { staticClass: "mb-1" }, [
              _vm._v(" " + _vm._s(item.title)),
            ]),
            _c("b-card-sub-title", { staticClass: "mb-2" }, [
              _vm._v(" " + _vm._s(item.description) + " "),
            ]),
            _c("vue-apex-charts", {
              attrs: {
                height: "350",
                type: "line",
                options: _vm.chartOptions(item.values),
                series: _vm.chartData(item.values),
              },
            }),
          ],
          1
        )
      }),
      _vm._l(_vm.reportEngagement.data, function (item) {
        return _c(
          "b-card",
          { key: item.id },
          [
            _c("b-card-title", { staticClass: "mb-1" }, [
              _vm._v(" " + _vm._s(item.title)),
            ]),
            _c("b-card-sub-title", { staticClass: "mb-2" }, [
              _vm._v(" " + _vm._s(item.description) + " "),
            ]),
            _c("vue-apex-charts", {
              attrs: {
                height: "350",
                type: "line",
                options: _vm.chartOptions(item.values),
                series: _vm.chartData(item.values),
              },
            }),
          ],
          1
        )
      }),
      _vm._l(_vm.pageContent.data, function (item) {
        return _c(
          "b-card",
          { key: item.id },
          [
            _c("b-card-title", { staticClass: "mb-1" }, [
              _vm._v(" " + _vm._s(item.title)),
            ]),
            _c("b-card-sub-title", { staticClass: "mb-2" }, [
              _vm._v(" " + _vm._s(item.description) + " "),
            ]),
            _c("vue-apex-charts", {
              attrs: {
                height: "350",
                type: "line",
                options: _vm.chartOptions(item.values),
                series: _vm.chartData(item.values),
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }